import {
    Box,
    TextField,
    Typography,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from '@mui/material';
import TransportPoint from './TransportPoint';


const Terminal = ({ terminal, index, setFieldValue, values }) => {
    const basePath = `terminals.${index}`;
    const usedTypes = values.terminals
        .filter((_, i) => i !== index)
        .map(t => t.type);

    return (
        <Box display="flex" flexDirection="column" p={2} gap={2} border={1}>
            <Typography variant="h6">Terminal #{index + 1}</Typography>

            <FormControl fullWidth variant="filled">
                <InputLabel>Terminal Type</InputLabel>
                <Select
                    value={terminal.type || ''}
                    onChange={(e) => {
                        const type = e.target.value;
                        setFieldValue(`${basePath}.type`, type);
                        setFieldValue(`${basePath}.airportPickupPoint`, {});
                        setFieldValue(`${basePath}.airportDropoffPoint`, {});
                    }}
                >
                    <MenuItem value="Domestic" disabled={usedTypes.includes('Domestic')}>
                        Domestic
                    </MenuItem>
                    <MenuItem value="International" disabled={usedTypes.includes('International')}>
                        International
                    </MenuItem>
                </Select>
            </FormControl>

            <TextField
                fullWidth
                variant="filled"
                label="Terminal Name"
                value={terminal.name || ''}
                onChange={(e) =>
                    setFieldValue(`${basePath}.name`, e.target.value)
                }
            />

            <TransportPoint
                label="Pickup Point"
                value={terminal.airportPickupPoint}
                onChange={(v) =>
                    setFieldValue(`${basePath}.airportPickupPoint`, v)
                }
            />

            <TransportPoint
                label="Dropoff Point"
                value={terminal.airportDropoffPoint}
                onChange={(v) =>
                    setFieldValue(`${basePath}.airportDropoffPoint`, v)
                }
            />

            <Button
                color="error"
                onClick={() =>
                    setFieldValue(
                        'terminals',
                        values.terminals.filter((_, i) => i !== index)
                    )
                }
            >
                Remove Terminal
            </Button>
        </Box>
    );
};

export default Terminal;
